/**
 * @generated SignedSource<<b0a4c46b2bf7e996d1a9e7fc2bf241f7>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
export type GoalCapabilitiesQuery$variables = {
  containerId: string;
  isM3GroupPermsEnabled: boolean;
};
export type GoalCapabilitiesQuery$data = {
  readonly goals_capabilities_extension?: {
    readonly canCreateGoal_extension: boolean | null | undefined;
    readonly canExportGoals_extension: boolean | null | undefined;
  } | null | undefined;
};
export type GoalCapabilitiesQuery = {
  response: GoalCapabilitiesQuery$data;
  variables: GoalCapabilitiesQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "containerId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isM3GroupPermsEnabled"
  }
],
v1 = [
  {
    "condition": "isM3GroupPermsEnabled",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "kind": "ClientExtension",
        "selections": [
          {
            "args": [
              {
                "kind": "Variable",
                "name": "containerId",
                "variableName": "containerId"
              }
            ],
            "concreteType": "TownsquareGoalAppCapabilities",
            "kind": "LinkedField",
            "name": "goals_capabilities_extension",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "canCreateGoal_extension"
              },
              {
                "kind": "ScalarField",
                "name": "canExportGoals_extension"
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "GoalCapabilitiesQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "GoalCapabilitiesQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "b51e46c1f60bf7206be1559a6271a6e9",
    "id": null,
    "metadata": {},
    "name": "GoalCapabilitiesQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "386f596ba2796121485918c36061cfe2";

export default node;
